import React from "react";
import { useSelector } from "react-redux";

/* The greeting at the top of the dashboard. */
export const WelcomeBanner = () => {
  const userInfo = useSelector((state) => state.auth.userInfo);
  const formattedDate = new Date().toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  return (
    <section className="relative flex items-center overflow-hidden rounded-[20px] border border-[var(--line)] bg-[linear-gradient(120deg,#ffffff_0%,#FBF5E9_100%)] px-6 py-6 sm:px-[34px]">
      <div className="min-w-0">
        <p className="mb-2 text-[12px] font-bold uppercase tracking-[.14em] text-[var(--gold-deep)] font-sans">
          {formattedDate}
        </p>
        <h2 className="truncate text-[24px] font-bold tracking-[-0.025em] text-[var(--ink)] font-sans sm:text-[31px]">
          Welcome {userInfo?.name ?? ""}
        </h2>
      </div>
    </section>
  );
};

export default WelcomeBanner;
